module.exports = __webpack_public_path__ + "static/media/artist-rush-cover.53061ee5.jpg";